import { createNamespacedHelpers } from 'vuex';
import { getFullNameUser } from 'Helpers/avatarHelper';
const importsStore = createNamespacedHelpers('importsStore');
import { importStatus } from 'stores/settings/settingsImportsStore';

export default {
    methods: {
        getUnavailableReasonToRevertImport(detail) {
            const itemFromDictionary = this.getMetadataImport.find(
                (item) => item.type === detail.type,
            );
            return itemFromDictionary?.unavailable_reason;
        },
        getRevertImportBtnLabel(detail) {
            const unavailableReasonToRevertImport = this.getUnavailableReasonToRevertImport(detail);
            if ([importStatus.QUEUED, importStatus.PROCESSING].includes(detail.status))
                return this.$l10n.__(
                    'Cette action sera disponible dès la fin du traitement de l’import',
                );
            if (unavailableReasonToRevertImport !== null) {
                return unavailableReasonToRevertImport === 'blocked_by'
                    ? this.$l10n.__(
                          'Cette action est temporairement indisponible pour éviter\n des erreurs sur vos données car un import du même type\n est déjà en cours de traitement',
                      )
                    : this.$l10n.__(
                          'Vous n’avez pas les droits nécessaires pour effectuer cette action',
                      );
            }
            return this.$l10n.__(
                "Cette action est indisponible 24h après\n la fin du traitement de l'import",
            );
        },
        isImportCanBeReverted(importDetail) {
            return (
                importDetail.is_revertible &&
                importDetail.processed_rows > 0 &&
                this.getUnavailableReasonToRevertImport(importDetail) === null
            );
        },
        isImportCancellable(log) {
            return log.status === importStatus.QUEUED;
        },
        getFullNameStaff(item) {
            if (item._embed.owner === null) {
                return this.$l10n.__('Collaborateur supprimé');
            }
            return this.$filters.capitalize(getFullNameUser(item._embed.owner));
        },
        getLabelForLine(importDetail, linesNumber, context = 'detail') {
            if (
                [importStatus.QUEUED, importStatus.CANCELLED, importStatus.FAILED].includes(
                    importDetail.status,
                )
            ) {
                return context === 'detail' ? '0' : '—';
            } else {
                return linesNumber.toLocaleString();
            }
        },
        adaptTypeForLegacy(type) {
            switch (type) {
                case 'company':
                    return { name: 'corporation', isV1: false };
                case 'comment':
                    return { name: 'annots', isV1: true };
                case 'service':
                case 'product':
                    return { name: 'catalogue', isV1: true };
                case 'product-variation':
                    return { name: 'declination', isV1: true };
                case 'stock':
                    return { name: 'inventory', isV1: true };
                case 'rate_category':
                    return { name: 'itemprices', isV1: true };
                case 'contact':
                    return { name: 'people', isV1: false };
                case 'opportunity':
                    return { name: type, isV1: true };
                default:
                    return { name: type, isV1: false };
            }
        },
        openLegacyImport(type) {
            const typeAdapted = this.adaptTypeForLegacy(type);

            typeAdapted.isV1
                ? Import.init(typeAdapted.name, false)
                : Import.create(typeAdapted.name, false);
        },
    },
    computed: {
        ...importsStore.mapGetters(['getMetadataImport']),
    },
};
